import React, { useEffect, useState } from 'react';
import { getCompletedCourses } from './utils/completedCourses';

export function useCompletedCourses () {

  const [completedData, setCompletedCourses] = useState<any>(null)
  const [completedDataLoaded, setCompletedDataLoaded] = useState(false)

  useEffect(() => {
    getCompletedCourses().then((response)=>{
      setCompletedCourses(response)
      setCompletedDataLoaded(true)
    }).catch((error)=>{
      setCompletedCourses([])
      setCompletedDataLoaded(true)
      console.error('Error fetching completed courses:', error);
    })
  }, []);

  return {
    completedData, completedDataLoaded
  }
}